<template>
 <main>
  <div class="page-rooter order-refund-detail-wrapper">
    <van-sticky>
      <van-nav-bar >
        <template #left>
          <van-icon color="black" name="arrow-left" @click="back" />
        </template>
        <template #title>
          <span>快捷开票</span>
        </template>
      </van-nav-bar>
    </van-sticky>
    <van-form @submit="onSubmit">
  

         <van-field
            v-model="form.gfmc"
            clearable
            name="gfmc"
            label="发票抬头"
            required
            placeholder="发票抬头"
            maxlength="50"
          > 
          <template #button>
              <van-icon name="search" @click="searchEnterpriseInfo()" />
           </template>   
          </van-field>    
        <van-field
          v-model.trim="form.gfsh"
          clearable
          name="gfsh"
          label="税号"
          placeholder="税号(必填)"
        />
     
        <van-field
              clearable
            v-model.trim="form.gfdzdh"
            label="地址电话"
            placeholder="地址电话"
        />
        <van-field
           clearable
            v-model.trim="form.gfyhzh"
            name="gfyhzh"
            label="开户行及账号"
            placeholder="开户行及账号"
        />
  
     
    
      <van-field
         clearable
        v-model.trim="form.mail"
        name="mail"
        label="推送邮箱"
        placeholder="推送邮箱" />
          <van-field
        v-model.trim="form.phone"
        clearable
        name="phone"
        label="手机号码"
        type="tel"
        maxlength="11"
        placeholder="手机号码">
      </van-field> 


      <van-field
        clearable
        v-model="form.remarks"
        name="remarks"
        rows="2"
        autosize
        type="textarea"
        label="发票备注"
        placeholder="发票备注" />

        <van-row style="padding-top:5px;padding-left:15px">
          <van-col span="8">商品</van-col>
          <van-col span="5">单价</van-col>
          <van-col span="3">数量</van-col>
          <van-col span="5">总价</van-col>
          <van-col span="2"><van-icon name="plus" @click="openDetails"/></van-col>
        </van-row>

       <van-row  style="padding-top:5px;padding-left:15px"
        v-for="(item, index) in  orderDetailsList" :key="index">
          <van-col span="8">{{item.spName}}</van-col>
          <van-col style="padding-left:5px" span="5">¥{{item.je}}</van-col>
          <van-col span="3">{{item.shuliang}}</van-col>
          <van-col span="5">¥{{item.orderZje}}</van-col>
          <van-col span="2"><van-icon name="edit" @click="openDetails(item,index)"/></van-col>
        </van-row>



      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit">提交</van-button >
      </div>
    </van-form>
    

  </div>

  <div class="selector">
    <van-popup v-model="showPicker" position="bottom" >

        <van-search  v-model="searchText" placeholder="搜索" @input="onSearch"> </van-search>
         <van-picker show-toolbar :columns="showOptions" @confirm="onConfirm"
         value-key="enterpriseName"
          @cancel="close" @change="onChange">
         </van-picker>
    </van-popup> 
  </div>




 <van-dialog v-model="addDetailsVisable" title="商品明细" :showConfirmButton="false" showCancelButton> 

  <van-form  @submit="updateData">
    <van-field
    v-model="orderDetailForm.totalPrice"
    name="totalPrice"
    label="金额"
    readonly
    placeholder="总价"
    :rules="[{ required: true, message: '请填写总价' }]"
  />
 

   <van-field
    v-model="orderDetailForm.price"
    name="price"
    type="number"
    label="单价"
    placeholder="单价"
     @blur="countTotalNum()"
    :rules="[{ required: true, message: '请填写单价' }]"
  />

    <van-field
    v-model="orderDetailForm.quantity"
    name="quantity"
    label="数量"
     type="digit"
     @blur="countTotalPrice()"
    placeholder="数量"
    :rules="[{ required: true, message: '请填写数量' }]"
  />

      <van-field
    v-model.trim="orderDetailForm.specifications"
    name="specifications"
    label="规格"
    placeholder="规格"
    :rules="[{ required: true, message: '请填写规格' }]"
  />

    <van-field
    v-model.trim="orderDetailForm.units"
    name="units"
    label="单位"
    placeholder="单位"
    :rules="[{ required: true, message: '请填写单位' }]"
  />
  

    <van-field
    v-model="orderDetailForm.taxRate"
    name="taxRate"
    label="税率"
    readonly
    placeholder="税率"
    :rules="[{ required: true, message: '请填写税率' }]"
  />
    <div style="margin: 16px;">
    <van-button round block type="info" native-type="submit">确认</van-button>
      <!-- <van-button round block type="info" >取消</van-button > -->
    </div> 
</van-form>
</van-dialog> 

 </main> 
</template>
<script>
// import invoiceDetails from './addInvoiceDetails.vue';
import Vue from "vue";
import {
   Col, Row,
  ActionSheet,
  Button,
  Collapse,
  CollapseItem,
  Field,
  Form,
  Cell, 
  CellGroup,
  Icon,
  NavBar,
  Radio,
  RadioGroup,
  Sticky,
  Tab,
  Tabs,
  Toast,
  Search,
  Picker,
  Dialog 
} from "vant";
Vue.use(Col);
Vue.use(Row);
Vue.use(Tabs);
Vue.use(Tab);
Vue.use(Icon);
Vue.use(Button);
Vue.use(Field);
Vue.use(Form);
Vue.use(NavBar);
Vue.use(ActionSheet);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Radio );
Vue.use(RadioGroup);
Vue.use(Sticky);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Search);
Vue.use(Picker);
Vue.use(Dialog);
export default {
  data() {
    return {
      orderDetailForm :{
      goodName:'',
      taxRate:'6%',
      price:1,
      quantity:1,
      totalPrice:1,
      specifications:'',
      units:'',
      },
      addDetailsVisable:false,
      showPicker:false,
      searchText: '', //搜索参数
      currentChoose: null, //当前选中值
      showOptions: [], //展示的下拉列表
      options:'',
      showPickerFplx: false,
      fplx: "",
      showPickerPickUp: false,
      pickUp: "",
      payed: "",
      purchasersUnit: "",
      taxpayerIdentityNumber: "",
      addRess: "",
      showSelectCustomer: false,
      memo: "",
      bank: "",
      tsbz:"",
      active:'0',
      orderId: '',
      tableData: [],
      orderDetailsList:[],
      tableRows:0,
      rows:'',
      tsbzshow:false,
      tsbzactions: [{ name: '短信',value:'1' }, { name: '邮件',value:'2' },{ name: '短信+邮件',value:'3' },],
      form: {
        gfyhzh:'',
        personal:'',
        gfsh:'',
        gfmc:'',
        gfdzdh:'',
        remarks:'',    //发票备注
        phone:'',  //手机
        mail:'',  //邮箱
        amountOfMoney:'',  //金额
        orderNo:'',    //订单号
        kpzdbs: "",
        jqbh: "",
        fplxdm: "",
        invoicingResults:''
      },
    };
  },

  created(){
      
     this.initHistoryHeader();  //取得历史发票抬头信息

  },
  methods: {

    updateData(){
            
           if(this.orderDetailForm.quantity*
        this.orderDetailForm.price> this.rows.orderZje){
                 Toast("开票金额不能大于支付金额");
           }else{
              this.rows.je= this.orderDetailForm.price;
              this.rows.shuliang= this.orderDetailForm.quantity;
              this.rows.orderZje=this.orderDetailForm.totalPrice;
              this.rows.specifications=this.orderDetailForm.specifications;
              this.rows.units=this.orderDetailForm.units;
              this.addDetailsVisable=false;
           }
    },
   countTotalNum(){   //单价输入，修改数量 
        
  
        this.orderDetailForm.quantity=
        (this.orderDetailForm.totalPrice/this.orderDetailForm.price).toFixed(3);
   },
    countTotalPrice(){   //数量输入，修改单价 


         this.orderDetailForm.price=
         (this.orderDetailForm.totalPrice/this.orderDetailForm.quantity).toFixed(3);

    },
    openDetails(item,index){    //打开明细
          this.orderDetailForm.taxRate=item.commodityTaxRate;
          this.orderDetailForm.price=item.je;
          this.orderDetailForm.quantity=item.shuliang;
          this.orderDetailForm.totalPrice=item.orderZje;
          this.orderDetailForm.specifications=item.specifications
          this.orderDetailForm.units=item.units;
          this.addDetailsVisable=true;
          this.tableRows=index;  //选择的行
          this.rows=item;

    },
    onChange(picker, value, index){   //选择改变事件
         console.log(value);
    },
    onConfirm(value, index){   //确认事件

        // console.log(value);
         this.form.gfmc=value.enterpriseName;
         this.form.gfsh=value.enterpriseCode;
         this.form.gfyhzh=value.bankAccount;
         this.form.gfdzdh=value.addressTelephone;
          this.showPicker=false;
    },
    close(){   //关闭弹窗
        this.showPicker=false;
    },

   searchEnterpriseInfo(){   
     
     if(this.form.gfmc==''){
        Toast("请输入企业名称");
     }else{
         const url = "/index/cloudRiseList";
          this.$axios
            .get(url,{enterpriseName:this.form.gfmc})
            .then((data) => {
               console.log(data);
              if(data.code==200){
                   this.showOptions = data.data;
                   this.options=data.data;
                   this.showPicker=true;
              }else{
               
                 Toast("未查找到企业");

              }
           
            })
            .catch((error) => {
              //请求失败返回的数
              Toast({
                message: error.message,
                position: "middle",
                duration: 2000,
              });
            });
     }
},

  onSearch(){  //内置的查询事件

     if (this.searchText === '' || this.searchText === null) {
        this.showOptions = this.options;
      } else {
             this.showOptions = this.options.filter((e) => e.enterpriseName.toLowerCase().indexOf(
             this.searchText.toLowerCase()) != -1)
      }

    },
    initHistoryHeader(){   //取得发票抬头信息

        var id = this.$route.query.orderid;
        const url = "/memberBusiness/enterprise/" + id + "/enterpriseListByOrderId";
        this.$axios
          .get(url)
          .then((data) => {
            this.form = data.data;
            this.orderDetailsList=data.data2;
          })
          .catch((error) => {
            //请求失败返回的数
            Toast({
              message: error.message,
              position: "middle",
              duration: 2000,
            });
          });

    },
    onSubmit(values) {  //提交订单

      var reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      var reg_email = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
       if(this.form.mail!==''){
        if(!reg_email.test(this.form.mail)){
           Toast('邮箱格式异常')
            return ''
        }
      }
     // console.log(1);
        if(this.form.phone!==''){
        if(!reg_tel.test(this.form.phone)){
             Toast('手机号格式异常');
              return ''
        }
      }
   //   console.log(2);
      if(this.form.phone===''&&this.form.mail===''){
        Toast('手机号和邮箱至少填写一个')
        return ''
      }
      // console.log(3);
     

        if(this.form.gfmc===''){
          Toast('公司名称不能为空')
          return ''
        }

        // if(this.form.gfsh===''){
        //   Toast('纳税人识别号不能为空')
        //   return ''
        // }
        // if(this.form.gfdzdh===''){
        //   Toast('地址电话不能为空')
        //   return ''
        // }
        // if(this.form.gfyhzh===''){
        //   Toast('开户行及账号不能为空')
        //   return ''
        // }

        
      

       this.$axios
        .post("/memberBusiness/invoice/"+this.$route.query.orderid+"/add",{
          gfmc:this.form.gfmc,
          gfsh:this.form.gfsh,
          gfdzdh:this.form.gfdzdh,
          gfyhzh:this.form.gfyhzh,
          orderZbId:this.$route.query.orderid,
          phone:this.form.phone,
          mail:this.form.mail,
          headType:this.active,
          remarks:this.form.remarks,
          invoicedetailsVoList:this.orderDetailsList
        }).then((data) => {
            Toast(data.message);
           this.$router.push({path: 'order', query: {status: -1}})
      });



    },

  
  },
};
</script>
<style>

</style>